// extracted by mini-css-extract-plugin
export default {"resetFormContainer":"styles_resetFormContainer__2EWVY"};